module.exports = __webpack_public_path__ + "static/media/right-arrow.60f86dcf.svg";